import { useWindowSize } from '@surveycake/rhooks';
import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import * as styles from './styles';

export function useThumbnail(videoId: string, onStart?: () => void) {
  const rootRef = useRef<HTMLDivElement>(null);
  const [thumbnail, setThumbnail] = useState();
  const [played, setPlayed] = useState(false);
  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (played) {
      return;
    }

    const rootElWidth = rootRef.current ? rootRef.current.offsetWidth : NaN;
    const style = {
      backgroundImage: `url("https://img.youtube.com/vi/${videoId}/mqdefault.jpg")`
    } as Partial<CSSProperties>;

    if (!isNaN(rootElWidth)) {
      style.width = rootElWidth;
      style.height = (rootElWidth * 356) / 640;
    }

    setThumbnail(
      <>
        <div
          className={styles.playIcon}
          onClick={() => {
            setPlayed(true);
            if (onStart) {
              onStart();
            }
          }}
        />
        <div className={styles.thumbnail} style={style} />
      </>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowWidth, rootRef.current, played]);

  return { rootRef, thumbnail, played };
}
